import { Pagination, paginationToParams } from '../../Pagination';
import { SortingOrder } from '../../SortingOrder';

export type StockReportOrderField = 'product-name' | 'quantity';

export interface StockReportFilter {
  minQuantity?: number;
  maxQuantity?: number;
  pagination: Pagination;
  orderBy: StockReportOrderField;
  order: SortingOrder;
}

export const getDefaultStockReportFilter = (): StockReportFilter => ({
  pagination: {
    page: 0,
    pageSize: 10,
  },
  orderBy: 'quantity',
  order: 'desc',
});

export const stockReportFilterToQueryParams = (filter: StockReportFilter) => {
  let order = '';
  switch (filter.orderBy) {
    case 'product-name': {
      order = filter.order === 'asc' ? 'nameAsc' : 'nameDes';
      break;
    }
    default: {
      order = filter.order === 'asc' ? 'quantityAsc' : 'quantityDesc';
      break;
    }
  }

  return {
    'min-quantity': filter.minQuantity,
    'max-quantity': filter.maxQuantity,
    'order-by': order,
    ...paginationToParams(filter.pagination),
  };
};
